import React from "react";

import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { useDispatch, useSelector } from "react-redux";

import { alertActions } from "../store/actions";

export const MuiAlert = () => {
    const dispatch = useDispatch();
    const alertInProgress = useSelector(state => state.alert.inProgress);

    const alert = useSelector(state => state.alert);

    const handleClose = () => {
        dispatch(alertActions.clear())
    }

    return <Snackbar open={alertInProgress} anchorOrigin={{ vertical: "top", horizontal: "left" }} autoHideDuration={3000} onClose={handleClose}>
        <Alert variant="filled" severity={alert.severity || undefined} sx={{ width: '100%' }}>
            {alert.message}
        </Alert>
    </Snackbar>
}